import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

const moods = [
  { emoji: '😄', label: 'pages.onboarding.feelings.great', value: 'great' },
  { emoji: '🙂', label: 'pages.onboarding.feelings.good', value: 'good' },
  { emoji: '😐', label: 'pages.onboarding.feelings.okay', value: 'okay' },
  { emoji: '😔', label: 'pages.onboarding.feelings.low', value: 'low' },
  { emoji: '😢', label: 'pages.onboarding.feelings.tough', value: 'tough' },
]

export default function MoodPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const noun = useCompanionNoun()

  return (
    <PageLayout>
      <div className="mx-auto flex w-full max-w-[520px] grow flex-col justify-center">
        <h2 className="text-primary mb-2 text-center font-serif text-3xl font-normal">
          {t('pages.onboarding.feelings.title')}
        </h2>
        <p className="text-muted mb-8 text-center">
          {t(toneVariant('pages.onboarding.feelings.subtitle'), { noun })}
        </p>

        <Form className="grid grid-cols-2 gap-3 md:grid-cols-5" method="post">
          {moods.map((mood) => (
            <button
              key={mood.value}
              name="mood"
              value={mood.value}
              onClick={(event) => {
                event.preventDefault()
                submit(event.currentTarget)
              }}
              className="border-surface rounded-[14px] border bg-white/80 px-2 py-4 text-center transition hover:-translate-y-0.5"
            >
              <div className="text-3xl">{mood.emoji}</div>
              <div className="text-primary mt-2 text-sm leading-tight font-semibold break-words hyphens-auto">
                {t(mood.label)}
              </div>
            </button>
          ))}
        </Form>
      </div>
    </PageLayout>
  )
}
